"use client";

import { cn } from "@/lib/utils";
import { useMemo } from "react";
import { InlineMath } from "react-katex";
import { t } from "@/lib/localization";

export default function Latex({
    text,
    latexSpanClassName,
}: {
    text: string;
    latexSpanClassName?: string;
}) {
    const parts = useMemo(
        () => text.split(/(\$[^$]+\$)/g).filter(Boolean),
        [text]
    );

    return (
        <>
            {parts.map((part, i) =>
                part.startsWith("$") && part.endsWith("$") ? (
                    <span
                        key={i}
                        className={cn("inline-block", latexSpanClassName)}
                        dir="ltr"
                    >
                        <InlineMath math={part.slice(1, -1)} />
                    </span>
                ) : (
                    <span key={i}>{part}</span>
                )
            )}
        </>
    );
}
